import { InAppState } from "../base/InAppState";
import template from "./NotFoundTemplate.html";

import { _lcs } from "../../i18n";

/**
 * NotFoundState — a route no state answers (an old or mistyped link).
 * Registered as the router's not-found state in App.init.
 *
 * Replaces InfrontJS' default, which writes its splash over the whole
 * container: that took the shell with it, so even `#/` stayed blank until a
 * reload (Funktionstest F7). This one renders into the page-content slot like
 * any screen. Signed out, InAppState's guard sends it on to the login.
 */
export class NotFoundState extends InAppState
{
    static ROUTE = null;
    static ID = "not-found";

    async enter()
    {
        const host = this.app.view.pageContent;
        if ( !host )
        {
            return;
        }
        this.app.view.render( host, template, {} );

        const home = host.querySelector( '[data-id="home"]' );
        if ( home )
        {
            this.addEventListener( home, "click", () => this.app.router.redirect( "/" ) );
        }
    }

    getContentHeaderData()
    {
        return {
            title: _lcs( "Seite nicht gefunden" ),
            breadcrumb: []
        };
    }
}
